import React, { useEffect, Fragment } from 'react';
import { Card } from 'reactstrap';
import {connect} from 'react-redux';
import icon_team from '../../../../assets/img/Talentsandteams.svg';
import { NavLink as Link } from 'react-router-dom';
import { teamsListActions, getCurrentTeamsList, getTeamsForCurrentTeamsList } from '../../../../core/teams-list';
import TeamItem from '../../../components/teams/team-item';

const TeamsHome = ({teams, loadTeams}) => {

  useEffect(()=>{
    loadTeams('all')
  },[loadTeams])

  return (
    <Card className="mb-4">
      <div className="d-flex align-items-center justify-content-between border-bottom p-3">
          <h2 className="h3 mb-0"><i className='mr-3'><img src={icon_team} width="32" height="32" alt='teams' className='mb-1'/></i>Teams</h2>
          
            {teams.size > 0 &&
              <Link to='/teams' className="btn btn-sm btn-green-light">
                <i className="mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="currentColor" style={{marginBottom:'3px'}} viewBox="0 0 11.82 11.82">
                  <path d="M.26,5.56c.07,.05,.15,.09,.23,.11,.08,.02,.17,.03,.26,.01,.09-.01,.17-.04,.24-.08,.07-.04,.14-.1,.19-.17,.24-.33,.56-.59,.93-.77,.36-.18,.77-.28,1.17-.28s.81,.09,1.17,.28c.36,.18,.68,.45,.93,.77,.1,.14,.26,.23,.43,.26,.17,.02,.35-.02,.49-.12,.05-.04,.09-.08,.13-.13,.24-.33,.56-.59,.93-.77,.36-.18,.77-.28,1.17-.28s.81,.09,1.17,.28c.36,.18,.68,.45,.93,.77,.05,.07,.12,.13,.19,.17,.07,.04,.16,.07,.24,.09,.09,.01,.17,0,.26-.01,.08-.02,.16-.06,.23-.11,.07-.05,.13-.12,.17-.19,.04-.07,.07-.16,.08-.24,.01-.09,0-.17-.02-.26s-.06-.16-.11-.23c-.36-.49-.84-.89-1.38-1.16,.24-.33,.38-.71,.41-1.11,.03-.4-.05-.81-.23-1.17-.18-.36-.46-.66-.81-.87C9.33,.11,8.94,0,8.53,0s-.8,.11-1.14,.32c-.34,.21-.62,.51-.81,.87-.18,.36-.26,.76-.23,1.17,.03,.4,.18,.79,.41,1.11-.31,.16-.6,.35-.86,.59-.26-.23-.55-.43-.86-.59,.24-.33,.38-.71,.41-1.11,.03-.4-.05-.81-.23-1.17-.18-.36-.46-.66-.81-.87-.34-.21-.74-.32-1.14-.32s-.8,.11-1.14,.32c-.34,.21-.62,.51-.81,.87-.18,.36-.26,.76-.23,1.17,.03,.4,.18,.79,.41,1.11-.54,.27-1.02,.67-1.38,1.16-.1,.14-.15,.31-.13,.49s.12,.33,.26,.43ZM8.53,1.31c.17,0,.34,.05,.49,.15,.14,.1,.26,.23,.32,.39,.07,.16,.08,.34,.05,.51-.03,.17-.12,.33-.24,.45-.12,.12-.28,.21-.45,.24-.17,.03-.35,.02-.51-.05-.16-.07-.3-.18-.39-.32-.1-.14-.15-.31-.15-.49,0-.23,.09-.45,.26-.62,.16-.16,.39-.26,.62-.26ZM3.28,1.31c.17,0,.34,.05,.49,.15,.14,.1,.26,.23,.32,.39,.07,.16,.08,.34,.05,.51-.03,.17-.12,.33-.24,.45-.12,.12-.28,.21-.45,.24-.17,.03-.35,.02-.51-.05-.16-.07-.3-.18-.39-.32-.1-.14-.15-.31-.15-.49,0-.23,.09-.45,.26-.62,.16-.16,.39-.26,.62-.26Zm7.02,8.29c.24-.33,.38-.71,.41-1.11,.03-.4-.05-.81-.23-1.17-.18-.36-.46-.66-.81-.87-.34-.21-.74-.32-1.14-.32s-.8,.11-1.14,.32c-.34,.21-.62,.51-.81,.87-.18,.36-.26,.76-.23,1.17,.03,.4,.18,.79,.41,1.11-.31,.16-.6,.35-.86,.59-.26-.23-.55-.43-.86-.59,.24-.33,.38-.71,.41-1.11,.03-.4-.05-.81-.23-1.17-.18-.36-.46-.66-.81-.87-.34-.21-.74-.32-1.14-.32s-.8,.11-1.14,.32c-.34,.21-.62,.51-.81,.87-.18,.36-.26,.76-.23,1.17,.03,.4,.18,.79,.41,1.11-.54,.27-1.02,.67-1.38,1.16-.1,.14-.15,.31-.13,.49,.02,.17,.12,.33,.26,.43,.14,.1,.31,.15,.49,.13,.17-.02,.33-.12,.43-.26,.24-.33,.56-.59,.93-.77,.36-.18,.77-.28,1.17-.28s.81,.1,1.17,.28c.36,.18,.68,.45,.93,.77,.1,.14,.26,.23,.43,.26,.17,.02,.35-.02,.49-.12,.05-.04,.09-.08,.13-.13,.24-.33,.56-.59,.93-.77,.36-.18,.77-.28,1.17-.28s.81,.1,1.17,.28c.36,.18,.68,.45,.93,.77,.05,.07,.12,.13,.19,.17,.07,.04,.16,.07,.24,.09,.09,.01,.17,0,.26-.01,.08-.02,.16-.06,.23-.11,.07-.05,.13-.12,.17-.19,.04-.07,.07-.16,.08-.24,.01-.09,0-.17-.02-.26-.02-.08-.06-.16-.11-.23-.36-.49-.84-.89-1.38-1.16ZM3.28,7.44c.17,0,.34,.05,.49,.15,.14,.1,.26,.23,.32,.39,.07,.16,.08,.34,.05,.51-.03,.17-.12,.33-.24,.45-.12,.12-.28,.21-.45,.24-.17,.03-.35,.02-.51-.05-.16-.07-.3-.18-.39-.32-.1-.14-.15-.31-.15-.49,0-.23,.09-.45,.26-.62,.16-.16,.39-.26,.62-.26Zm5.25,0c.17,0,.34,.05,.49,.15,.14,.1,.26,.23,.32,.39,.07,.16,.08,.34,.05,.51-.03,.17-.12,.33-.24,.45-.12,.12-.28,.21-.45,.24-.17,.03-.35,.02-.51-.05-.16-.07-.3-.18-.39-.32-.1-.14-.15-.31-.15-.49,0-.23,.09-.45,.26-.62,.16-.16,.39-.26,.62-.26Z"/>
                </svg>
                </i>View all Teams
              </Link>
            }
      </div>

      <div className='p-3'>

      { !teams.size && 
        <Fragment>
          <p className="my-4 mt-md-2">Start using these tools to increase collaboration with your team</p>
          <Link to='/teams' className="btn btn-sm btn-outline-green-light">
            <i className="mr-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px'}}>
                  <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z"/>
              </svg>
            </i>
            Let’s start!
          </Link>
        </Fragment>
      }
      
      {
        teams.size > 0 && <div className='team-grid grid-3'>

        {teams.filter((team, i) => i <= 2).map(item =>
          <Fragment key={item.id}>
            <TeamItem item={item}/>
          </Fragment>
        )}
        </div>
      }
      </div>
    </Card>
  )
}

const mapStateToProps = (state, props) => {
  const teams_list = getCurrentTeamsList(state, props);

  return {
    user: state.user,
    teams_list: teams_list,
    teams: getTeamsForCurrentTeamsList(state, props),
    displayLoadingIndicator: (teams_list && teams_list.isPending) || false,
  };
};

const mapDispatchToProps = {
  loadTeams: teamsListActions.loadTeams,
}

export default connect(mapStateToProps, mapDispatchToProps)(TeamsHome);
